var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { TimePicker } from 'antd';
import { BLACK } from 'ui/constants';
var StyledTimePicker = styled(TimePicker)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width, margin = _a.margin;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: 6px;\n    width: ", ";\n    margin: ", ";\n    .ant-picker-suffix {\n      color: ", ";\n    }\n  "], ["\n    border-radius: 6px;\n    width: ", ";\n    margin: ", ";\n    .ant-picker-suffix {\n      color: ", ";\n    }\n  "])), width || '100%', margin || 0, BLACK);
});
export default StyledTimePicker;
var templateObject_1, templateObject_2;
